/**
* Image Gallery Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Gallery Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'image-gallery-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.image-gallery-slider-splide' ).length ) {
        $( '.image-gallery-slider-splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            pagination: false,
            focus: 'center',
            fixedHeight: '545px',
            autoWidth: true,

            breakpoints: {
              768: {
                fixedHeight: 'auto',
                padding: '0rem',
              },
            },
          } );

          if ( $( element ).hasClass( 'condensed' ) ) {
            splide.options.padding = '5rem';
          }

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-gallery-slider', COMPONENT );
} )( app );
